import React from 'react';

interface TableProps { headers: string[]; children: React.ReactNode; }

export const Table: React.FC<TableProps> = ({ headers, children }) => (
  <div style={{ overflowX: 'auto' }}>
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
      <thead>
        <tr>
          {headers.map(h => (
            <th key={h} style={{ textAlign: 'left', padding: '6px 8px', color: '#888780', fontWeight: 500, borderBottom: '0.5px solid rgba(0,0,0,0.1)' }}>
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  </div>
);

export const Tr: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <tr style={{ borderBottom: '0.5px solid rgba(0,0,0,0.06)' }}>{children}</tr>
);

export const Td: React.FC<{ children: React.ReactNode; style?: React.CSSProperties }> = ({ children, style }) => (
  <td style={{ padding: '8px 8px', ...style }}>{children}</td>
);
